import FormSelectSearch from "components/NewForm/FormSelectSearch";
import NewTable, { TableHeaderColumn } from "components/NewTable";
import PageDefault from "components/PageDefault";
import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import companyService from "services/company.service";
import fundService from "services/fund.service";
import paymentService from 'services/payment.service'
import { formatDocument } from "utils/format";
import { makeid } from "utils/random";

export default function Extract(){
  const [ KEY_TABLE, setkeytable ] = useState(makeid(5))
  const [ PaymentMethod, SetPaymentMethod ] = useState<any[]|null>(null);
  const [ companiesList, setCompaniesList ] = useState<any[]>([]);
  const [ data, setData ] = useState([]);
  const [ filter, setFilter ] = useState({company_id:null});
  const [ load, setLoad ] = useState(true);
  
  useEffect(()=>{
    companyService.get({params:{
      fields:"id,name,document"
    }}).then((data)=>{
      setCompaniesList(data.map((item:any)=>{
        return {
          value:item.id,
          name:`${item.name} - ${formatDocument(item.document)}`
        }
      }))
    })
    paymentService.get().then((data:any[])=>{
      SetPaymentMethod(data);
      setkeytable(makeid(5))
    })
  },[]);

  useEffect(()=>{
    setLoad(true)
    fundService.getExtract(filter).then(data=>{
      setData(data)
      setLoad(false)
    })
  },[filter]);
  

  return (
    <PageDefault title="Extrato">
      <PageDefault.Title>Extrato</PageDefault.Title>
      <PageDefault.Content>
        <Row>
          <FormSelectSearch title={"Empresa"} md="4" name="company_id" onChange={(d:any)=>{
            if(d)
              setFilter((old:any)=>({...old, company_id:d.value}));
            else
              setFilter((old:any)=>({...old, company_id:null}));
          }} options={[...companiesList]} value={filter.company_id} cleanable/>
        </Row>
        <NewTable data={data} hideTopBar load={load} key={KEY_TABLE}
        tableLayoutFixed
        expandRow={{
          render: (item:any, row:number)=>{
            return item.status.map((d:any)=>{
              return {
                ...d,
                type:d.status,
              }
            });
          },
          type:"ROW",
          getColumnInfo:true,
          style:{backgroundColor:"#4040402b"}
        }}>
          <TableHeaderColumn dataField="type">Tipo</TableHeaderColumn>
          {PaymentMethod!==null?PaymentMethod.map((item,key)=>{
            return <TableHeaderColumn key={key} dataField={"methods."+item.id} type={"CURRENCY"}>{item.name}</TableHeaderColumn>;
          }):<></>}
        </NewTable>
      </PageDefault.Content>
    </PageDefault>
  );
}